<template>
    <div class="card" v-if="!loading">
        <div class="card-header bg-info text-white fs-3">
            <i class="bi bi-book me-2"></i> {{ planned_subject.subject_name }}
        </div>
        <div class="card-body">
            <div class="d-flex justify-content-end gx-1 mb-3">
                <div>
                    <form-select
                        v-model="condition.school_class_id"
                        :options="school_classes"
                    ></form-select>
                </div>
                <div>
                    <router-link
                        :to="{name: 'PageGalleryCommentFromMe', params: { subject: parseInt($route.params.subject, 10) }}"
                        class="btn btn-warning ms-1"
                        v-if="planned_subject.option_comment !== OptionComment.NONE"
                    >
                        <i class="bi bi-chat-dots"></i>
                    </router-link>
                </div>
                <div>
                    <router-link
                        :to="{name: 'PageGalleryCommentToMe', params: { subject: parseInt($route.params.subject, 10) }}"
                        class="btn btn-success ms-1"
                        v-if="planned_subject.option_comment !== OptionComment.NONE && planned_subject.option_comment_disclosed !== OptionCommentDisclosed.HIDE"
                    >
                        <i class="bi bi-chat-fill"></i>
                    </router-link>
                </div>

            </div>
            <div class="col pt-1 mb-2 fs-5 fw-bold text-center">
                <template v-if="is_muji">
                    {{ $t('みんなの写真') }}
                </template>
                <template v-else>
                    {{ $t('みんなの作品') }}
                </template>
            </div>

            <div class="row g-1">
                <template v-if="student_photos.length">
                    <template v-for="photo of student_photos" :key="photo">
                        <router-link
                            class="square col-8"
                            :to="{ name: 'PageGalleryView', params: { subject: parseInt($route.params.subject, 10), worksheet: photo.student_worksheet_id } }"
                        >
                            <img :src="photo.file.thumbnail_url" alt="">
                        </router-link>
                    </template>
                </template>
                <alert-no-record :text="is_muji ? `${$t('みんなの写真')}はありません` : `${$t('みんなの作品')}はありません`" v-else></alert-no-record>
            </div>
        </div>
    </div>
</template>

<script>
import SchoolClass from '@/shared/models/entities/school-class';
import PlannedSubject from '@/shared/models/entities/repocraft/planned-subject';
import StudentPhoto from '@/shared/models/entities/repocraft/student-photo';
import OptionComment from '@/shared/models/enums/option-comment';
import OptionCommentDisclosed from '@/shared/models/enums/option-comment-disclosed';
import OptionWorkShare from '@/shared/models/enums/option-work-share';
import FormSelect from '@/shared/components/form/FormSelect';
import AlertNoRecord from '@/shared/components/design/AlertNoRecord.vue';

export default {
    name: 'PageGallery',
    components: {
        FormSelect,
        AlertNoRecord,
    },
    inject: [
        'startScreenLoading',
        'endScreenLoading',
        'showMessage',
        'showErrorMessage',
    ],
    data() {
        return {
            loading: 0,

            // レポクラフト無地判定
            is_muji: false, //default = repocraft

            //題材名
            planned_subject: new PlannedSubject(),

            //画像一覧
            student_photos: [],

            //自分がコメントした数
            comment_from_me_count: null,
            //自分がコメントされた数
            comment_to_me_count: null,

            //クラス選択肢
            school_classes: [],

            condition: {
                school_class_id: null,
            },

            //enums
            OptionComment: OptionComment,
            OptionCommentDisclosed: OptionCommentDisclosed,
            OptionWorkShare: OptionWorkShare,
        }
    },
    mounted() {
        this.startScreenLoading();

        //クラスの選択肢取得
        this.fetchSchoolClasses();

        //題材詳細の取得
        this.loading++;
        this.$http.get(`/repocraft/subject/${parseInt(this.$route.params.subject, 10)}`)
        .then(response => {
            this.planned_subject = new PlannedSubject(response.data);

            //レポクラフト/レポクラフト無地を判定
            if (this.planned_subject.app_key === 'repocraft_muji') {
                this.is_muji = true;
            }

            //作品・写真 共有が許可されていなければリダイレクト
            if (this.planned_subject.option_work_share === OptionWorkShare.NONE) {
                this.endScreenLoading();
                this.showErrorMessage(this.is_muji ? this.$t('いま写真は見られません') : this.$t('いま作品は見られません'));
                this.$router.push({name: 'PageHome'});
                return;
            }

            //自分へのコメント数・自分が書いたコメント数を取得する
            this.fetchCommentSummary();
        })
        .finally(() => {
            this.endScreenLoading();
            this.loading--;
        });
    },
    watch: {
        'condition.school_class_id'() {
            //作品・写真リストの取得
            this.fetchGallery();
        }
    },
    methods: {
         //クラスの選択肢取得
        fetchSchoolClasses() {
            this.startScreenLoading();
            this.loading++;

            this.$http.get(`/repocraft/school-class`)
            .then(response => {
                for(let row of response.data) {
                    var school_class = new SchoolClass(row);
                    this.school_classes.push({key: school_class.school_class_id, label: school_class.class_name_display});
                }
                //storeに前回の検索条件があればconditionに代入、ないときは自分のクラス
                let condition = this.$store.getters['repocraft/condition/merge']('PageGallery', this.condition);

                if (
                    this.$helper.isNud(condition.school_class_id) ||
                    !response.data.some(school_class => school_class.school_class_id === condition.school_class_id)
                ) {
                    this.condition.school_class_id = this.$store.state.repocraft.auth.school_class.school_class_id;

                } else {
                    this.condition.school_class_id = condition.school_class_id;
                }
            })
            .finally(() => {
                this.endScreenLoading();
                this.loading--;
            });
        },
        //作品・写真リストの取得
        fetchGallery() {
            this.startScreenLoading();
            this.loading++;

            //リストを一旦空にする
            this.student_photos.splice(0);

            this.$http.get(`/repocraft/subject/${parseInt(this.$route.params.subject, 10)}/gallery`, {
                params: {
                    school_class_id: this.condition.school_class_id,
                }
            })
            .then(response => {
                for (let row of response.data) {
                    this.student_photos.push(new StudentPhoto(row));
                }

                //検索条件を保存
                this.$store.commit('repocraft/condition/setSearchCondition', {
                    page: 'PageGallery',
                    condition: this.condition
                });
            })
            .finally(() => {
                this.loading--;
                this.endScreenLoading();
            });
        },
        //自分へのコメント数・自分が書いたコメント数を取得する
        fetchCommentSummary() {
            this.startScreenLoading();
            this.loading++;

            this.$http.get(`/repocraft/subject/${parseInt(this.$route.params.subject, 10)}/gallery/comment-summary`)
            .then(response => {
                this.comment_from_me_count = response.data.comment_from_me_count;
                this.comment_to_me_count = response.data.comment_to_me_count;
            })
            .finally(() => {
                this.endScreenLoading();
                this.loading--;
            });
        }
    },
}
</script>

<style scoped>
.square {display: block; height: 7.5rem;}
.square img {width: 100%; height: 100%; object-fit: cover;}
</style>
